document.addEventListener('change', function (e) {
  // Check if user clicked on bundle-choice radio
  const clicked = e.target.closest('.bundle-option input[name="bundle-choice"]');
  if (!clicked) return;

  // Find the selected bundle option wrapper
  const selectedOption = e.target.closest('.bundle-option');
  if (!selectedOption) return;

  // Remove active class from all bundle options
  document.querySelectorAll('.bundle-option').forEach((opt) => {
    opt.classList.remove('active');
  });

  // Add active class to the selected one
  selectedOption.classList.add('active');

  // Get both Appstle radio inputs
  const appstleOneTime = document.querySelector(
    '.appstle_subscription_wrapper input#appstle_selling_plan_label_10'
  );
  const appstleSubscribe = document.querySelector(
    '.appstle_subscription_wrapper input#appstle_selling_plan_label_20'
  );

  // Safety check: only proceed if both exist
  if (!appstleOneTime || !appstleSubscribe) {
    console.warn('⚠️ Appstle inputs not found.');
    return;
  }

  // Logic: Match class and trigger corresponding Appstle input
  if (selectedOption.classList.contains('subscribe_save')) {
    // Select "Subscribe and Save"
    appstleSubscribe.checked = true;
    appstleSubscribe.dispatchEvent(new Event('change', { bubbles: true }));
    selectedOption.closest(".variant-wrapper").classList.add("subscribe_save_active");
    selectedOption.closest(".variant-wrapper").classList.remove("onetime_active");

    
    console.log('✅ Switched to Subscribe & Save');
  } else if (selectedOption.classList.contains('one_time')) {
    // Select "One Time Purchase"
    appstleOneTime.checked = true;
    appstleOneTime.dispatchEvent(new Event('change', { bubbles: true }));
     selectedOption.closest(".variant-wrapper").classList.remove("subscribe_save_active");
    selectedOption.closest(".variant-wrapper").classList.add("onetime_active");
    
    const { html, price } = getOneTimePriceDetails();
    
   getOneTimeCustomButton(selectedOption, html, price) 
    console.log(price);
    console.log('✅ Switched to One Time Purchase');
  }

  updateCurrentPrice();
  updateAppstleSelectBasedOnQuantity();


});




function updateAppstleSelectBasedOnQuantity() {
  setTimeout(() => {
  // Find the checked Quantity radio
  const checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  if (!checkedRadio) {
    console.warn("⚠️ No Quantity option selected");
    return;
  }

  const quantityValue = checkedRadio.value.trim(); // e.g. "2x bags + FREE accessories"
  console.log("🟢 Selected Quantity:", quantityValue);

  // Extract number before "x"
  const match = quantityValue.match(/^(\d+)/);
  if (!match) return;

  const number = match[1]; // "1", "2", or "3"
  console.log("📦 Extracted number:", number);
  activateVariantWrappers_multicolor(number);
  updateFlavourProperties();

  // Find the Appstle dropdown
  const selectBox = document.querySelector(".appstle_custom_select select.appstle_select");
  if (!selectBox) {
    console.warn("⚠️ Appstle select box not found");
    return;
  }

  // Find option matching that number (e.g. "1 Monthly Subscription")
  const matchingOption = Array.from(selectBox.options).find(opt =>
    opt.textContent.trim().startsWith(number)
  );

  if (matchingOption) {
    selectBox.value = matchingOption.value;
    console.log(`✅ Selected ${matchingOption.textContent} in dropdown`);
    selectBox.dispatchEvent(new Event("change", { bubbles: true }));
  } else {
    console.warn("⚠️ No matching option found for:", number);
  }

  updateCurrentPrice(number);
  activateGiftsUpTo(number);
  const { html, price } = getOneTimePriceDetails();
    var  selectedOptionOne_new = document.querySelector(".bundle-option.one_time");
   getOneTimeCustomButton(selectedOptionOne_new, html, price) 
}, 50);
}

function waitForAppstleWidget() {
  const widget = document.querySelector("#appstle_subscription_widget0");
  if (widget) {
    console.log("🟢 Appstle widget found — running update logic");
      const variantWrapperWrap = document.querySelector(".variant-wrapper");
      variantWrapperWrap.classList.remove("variant-wrapper-disable");

    updateAppstleSelectBasedOnQuantity();
  } else {
    console.log("⏳ Waiting for Appstle widget...");
    setTimeout(waitForAppstleWidget, 300); // check again in 300ms
  }
}

function activateGiftsUpTo(count) {
  const gifts = document.querySelectorAll(".gifts-wrapper .gift-item-wrap");
  if (!gifts.length) return;

  // Clear all first
  gifts.forEach(gift => gift.classList.remove("active"));

  // Apply logic
  if (count >= gifts.length || count >= 3) {
    // activate all
    gifts.forEach(gift => gift.classList.add("active"));
  } else {
    // activate up to count
    gifts.forEach((gift, i) => {
      if (i < count) gift.classList.add("active");
    });
  }
}

function updateCurrentPrice(number) {

  handleBundleSelection();
  
  // Find the wrapper
  const wrapper = document.querySelector('.appstle_subscription_wrapper');
  if (!wrapper) return;

  // Find the checked radio button inside the wrapper
  const checkedRadio = wrapper.querySelector('input[name="selling_plan"]:checked');
  if (!checkedRadio) return;

  // Find the nearest subscription option block
  const optionBlock = checkedRadio.closest('.appstle_subscription_wrapper_option');
  if (!optionBlock) return;

  const amountWrapperHTML = optionBlock.querySelector(".appstle_subscription_amount_wrapper")?.outerHTML;
  console.log(amountWrapperHTML);
  // Get price text
  const priceEl = optionBlock.querySelector('.appstle_subscription_amount.transcy-money');
  const priceText = priceEl ? priceEl.textContent.trim() : '';

  // Get discount badge text if available
  const badgeEl = optionBlock.querySelector('.appstle-save-badge');
  const badgeText = badgeEl ? ` (${badgeEl.textContent.trim()})` : '';

  // Append to .curr-prc
  const currPrcEl = document.querySelector('.curr-prc');
  const saveBadgAmt = document.querySelector('.save-badge-amt');
  const saveBadgeCompare = document.querySelector(".save-badge-off-compare");
  if(saveBadgeCompare && amountWrapperHTML){
//  saveBadgeCompare.innerHTML = amountWrapperHTML;
 const { savedAmount, percentSaved, salePrice } = getAmountSavedFromHTML(amountWrapperHTML);

 var sav_amt = (salePrice/number).toFixed(2);;
// console.log("sav_amt- salePrice", sav_amt +'  '+ typeof number);
  // updateSavingBadge(savedAmount);
       
  }


  // if(saveBadgAmt)
  // {
  //   // saveBadgAmt.textContent = ` ${badgeText}`;
  //   saveBadgAmt.textContent = ` (£${sav_amt} Per Tub)`;

  // }

  if (currPrcEl && priceText) {
    // currPrcEl.textContent = ` ${priceText}${badgeText}`;
    const total = (parseFloat(priceText.replace(/[^\d.]/g,"")) * number).toFixed(2);
const final = priceText[0] + total;

console.log("final",final);

    currPrcEl.textContent = `  ${final}`;

    console.log("priceText", priceText +' '+ number);
    updateSavePerBundle(priceText);

    const priceTextOrig = document.querySelector(
  ".appstle_sub_widget .appstle_one_time_details_wrapper .appstle_subscription_amount.transcy-money"
);
let integerOrig = 0;
if (priceTextOrig) {
  integerOrig = parseFloat(priceTextOrig.textContent.replace(/[^0-9.]/g, ""), 10);
  console.log("integerOrig",integerOrig);
}

    if(saveBadgAmt)
  {
    // saveBadgAmt.textContent = ` ${badgeText}`;
 saveBadgeCompare.innerHTML = `<div class="appstle_subscription_amount_wrapper">
                  <span class="appstle_subscription_amount transcy-money">(${final})</span>
                  
                  <span class="appstle_subscription_compare_amount transcy-money">£${(integerOrig*parseInt(number, 10)).toFixed(2)}</span>
                  
                </div>`;

                updateSavingBadge((((integerOrig*parseInt(number, 10)).toFixed(2))-total).toFixed(2));

    saveBadgAmt.textContent = ` (£${(total/parseInt(number, 10)).toFixed(2)} Per Tub)`;

  }
  }
}


function updateSavingBadge(saveAmount) {
  const checkedInput = document.querySelector('input[name="Quantity"]:checked');
  const allQuantityInputs = document.querySelectorAll('input[name="Quantity"]');

  // Hide all badges first
  allQuantityInputs.forEach(eachInput => {
    const nextLabel = eachInput.nextElementSibling;
    const badge = nextLabel?.querySelector(".s_sub_saving_badge");
    if (badge) badge.classList.add("hidden");
  });

  // Show badge for checked one and update text
  if (checkedInput) {
    const nextLabel = checkedInput.nextElementSibling;
    const badge = nextLabel?.querySelector(".s_sub_saving_badge");
    if (badge) {
      badge.classList.remove("hidden");
      const money = badge.querySelector(".money");
      if (money) money.textContent = `£${saveAmount}`;
    }
  }
}


function updateSavePerBundle(priceText){
    const updatesave_checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  if (!updatesave_checkedRadio) {
    console.warn("⚠️ No Quantity option selected");
    return;
  }

  const updatesave_quantityValue = updatesave_checkedRadio.value.trim(); // e.g. "2x bags + FREE accessories"
  console.log("🟢 Selected Quantity:", updatesave_quantityValue);

  // Extract number before "x"
  const updatesave_match = updatesave_quantityValue.match(/^(\d+)/);
  if (!updatesave_match) return;

  const updatesave_number = updatesave_match[1]; // "1", "2", or "3"
  const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ""));
  const pricePerBundle = (numericPrice / updatesave_number).toFixed(2);
  console.log("📦 pricePerBundle Extracted number:", pricePerBundle);
}



function getAmountSavedFromHTML(amountWrapperHTML) {
  if (!amountWrapperHTML) return { savedAmount: 0, percentSaved: 0 };

  // Create a temporary DOM to parse the string
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = amountWrapperHTML.trim();

  const saleEl = tempDiv.querySelector(".appstle_subscription_amount");
  const compareEl = tempDiv.querySelector(".appstle_subscription_compare_amount");

  if (!saleEl || !compareEl) return { savedAmount: 0, percentSaved: 0 };

  const salePrice = parseFloat(saleEl.textContent.replace(/[£,]/g, ""));
  const comparePrice = parseFloat(compareEl.textContent.replace(/[£,]/g, ""));

  if (isNaN(salePrice) || isNaN(comparePrice) || comparePrice <= salePrice)
    return { savedAmount: 0, percentSaved: 0 };

  const savedAmount = +(comparePrice - salePrice).toFixed(2);
  const percentSaved = +(((comparePrice - salePrice) / comparePrice) * 100).toFixed(0);

  return { savedAmount, percentSaved, salePrice };
}


// Run when user changes Quantity
document.addEventListener("change", function (event) {
  if (event.target.name === "Quantity") {
    updateAppstleSelectBasedOnQuantity();
  }
});

// Run on initial load (after widget is available)
window.addEventListener("DOMContentLoaded", waitForAppstleWidget);



function getOneTimePriceDetails() {
  const priceEl = document.querySelector(
    '.appstle_one_time_details_wrapper .appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money'
  );

  if (!priceEl) {
    return null; // element not found
  }

  const html = priceEl.outerHTML;
  const text = priceEl.textContent.trim();

  // Extract numeric value safely (handles "£74.99" or "USD 74.99")
  const numeric = parseFloat(text.replace(/[^0-9.]/g, ''));

  // If not a valid number, skip
  if (isNaN(numeric)) {
    return null;
  }

  return { html, price: numeric };
}

function getOneTimeCustomButton(selectedOptionOne, html, price) {
  if (!selectedOptionOne) return;

  // update the compare badge HTML
  const compareBadge = selectedOptionOne.querySelector(".save-badge-off-compare");
  // if (compareBadge) compareBadge.innerHTML = html;

  // get selected quantity (e.g., "1 Month Supply" → 1)
  const checked = document.querySelector('input[name="Quantity"]:checked');
  if (!checked) return;

  const match = checked.value.match(/(\d+)/);
  const number = match ? Number(match[1]) : null;
  if (!number || isNaN(price)) return;

  // calculate per-tub saving or price
  const perTub = (price / number).toFixed(2);
  if (!number || isNaN(price)) return;
console.log("onetime orr tube",number );
  // update per-tub text
  const saveBadgeOff = selectedOptionOne.querySelector(".save-badge-off .save-badge-amt");
  if (saveBadgeOff) {
    // saveBadgeOff.textContent = ` (£${perTub} Per Tub)`;
    saveBadgeOff.textContent = ` (£${price} Per Tub)`;
  }
  if (compareBadge) compareBadge.innerHTML =  `<div class="appstle_subscription_amount_wrapper">
                  <span class="appstle_subscription_amount transcy-money">(£${price*number})</span>
                  
                   <span class="appstle_subscription_compare_amount transcy-money"></span>
                  
                </div>`;

    

}



// select the multiflavour
document.addEventListener('DOMContentLoaded', () => {
  const flavourSnippets = document.querySelectorAll('.custom-flavour-snippet');

  flavourSnippets.forEach(snippet => {
    snippet.addEventListener('click', e => {
      const label = e.target.closest('label.qty-image-element-wrap');
      if (!label) return;

      const wrapper = label.closest('.variant-wrapper');
      if (!wrapper) return;

      // ✅ Only modify labels inside this wrapper
      wrapper.querySelectorAll('label').forEach(l => l.classList.remove('active'));
      label.classList.add('active');

      // ✅ Build data object only from active wrappers
      const data = {};

      snippet.querySelectorAll('.variant-wrapper.active').forEach(activeWrapper => {
        const boxQty = activeWrapper.getAttribute('data-boxqty');
        const activeLabel = activeWrapper.querySelector('label.active');
        const flavour = activeLabel ? activeLabel.getAttribute('data-flavour') : null;

        if (boxQty && flavour) {
          data[boxQty] = flavour;
        }
      });

      console.log(data); // 👉 Only active wrappers’ flavour selections
      updateFlavourProperties();
    });
  });
});


  function activateVariantWrappers_multicolor(count) {
  // Get all .variant-wrapper inside .custom-flavour-snippet
  const wrappers = document.querySelectorAll('.custom-flavour-snippet .variant-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper, index) => {
    // Add 'active' to first 'count' wrappers, remove from others
    if (index < count) {
      wrapper.classList.add('active');
    } else {
      wrapper.classList.remove('active');
    }
  });
}



function updateFlavourProperties() {
//   const form = document.querySelector('.product-form.main-product-form form');
//   if (!form) {
//     console.warn('Product form not found');
//     return;
//   }

//   // Remove existing inputs
//   form.querySelectorAll('.multiflavout-property').forEach(el => el.remove());

//   // Build flavour data from active variant wrappers
//   const data = {};
//   document.querySelectorAll('.custom-flavour-snippet .variant-wrapper.active').forEach(wrapper => {
//     const boxQty = wrapper.getAttribute('data-boxqty');
//     const activeLabel = wrapper.querySelector('label.active');
//     const flavour = activeLabel ? activeLabel.getAttribute('data-flavour') : null;
//     if (boxQty && flavour) {
//       data[boxQty] = flavour;
//     }
//   });

//   // Create new hidden inputs
//   Object.entries(data).forEach(([boxQty, flavour]) => {
//     const input = document.createElement('input');
//     input.type = 'hidden';
//     input.className = 'multiflavout-property';
//     input.name = `properties[${boxQty}]`;
//     input.value = flavour;
//     form.appendChild(input);
//   });
}


// CUSTOM ADD TO CART

function getSelectedVariantData() {
  const prodJson_multi = document.getElementById("custom-prod-data-json");
  const productData_multi = JSON.parse(prodJson_multi.textContent);

  // 1. Get selected Quantity
  const checkedRadio = document.querySelector('input[name="Quantity"]:checked');
  const quantityValue = checkedRadio ? checkedRadio.value.trim() : null;

  // 2. Get selected Subscription / Selling Plan
  const sellingPlanSelect = document.querySelector('.appstle_custom_select select');
  const sellingPlanId = sellingPlanSelect ? sellingPlanSelect.value : null;

  // 3. Collect selected flavours
  const selectedFlavours = [];
  document.querySelectorAll('.variant-wrapper.active').forEach(wrapper => {
    const activeLabel = wrapper.querySelector('label.active');
    const flavour = activeLabel ? activeLabel.getAttribute('data-flavour') : null;

    if (flavour) selectedFlavours.push(flavour);
  });

  // 4. Match flavour + quantity to variant
  const matchedData = selectedFlavours.map(flavour => {
    const variant = productData_multi.variants.find(v =>
      v.option1.toLowerCase() === flavour.toLowerCase() &&
      v.option2.toLowerCase() === quantityValue.toLowerCase()
    );

    return {
      flavour: flavour,
      quantity: quantityValue,
      sellingPlanId: sellingPlanId,
      variantId: variant ? variant.id : null
    };
  });

  return matchedData;
}


async function addSelectedVariantsToCart() {
  const selectedData = getSelectedVariantData(); // your function output

  if (!selectedData || selectedData.length === 0) {
    console.error("No selected variants found");
    return;
  }

  // // Build items array for Shopify
  // const items = selectedData.map(item => {
  //   if (!item.variantId) {
  //     console.error("Variant not found for:", item);
  //     return null;
  //   }

  //   return {
  //     id: item.variantId,
  //     quantity: 1,
  //     selling_plan: item.sellingPlanId, // subscription
  //     properties: {
  //       Flavour: item.flavour,
  //       Quantity: item.quantity
  //     }
  //   };
  // }).filter(Boolean); // remove nulls

  // 1. Group duplicates by variantId
const grouped = {};

var curr_Sel_opt = document.querySelector(".bundle-option.active").dataset.vall;

selectedData.forEach(item => {
  if (!item.variantId) return;

  const key = item.variantId;

  if (!grouped[key]) {
    grouped[key] = {
      id: item.variantId,
      quantity: 0,
      selling_plan: item.sellingPlanId,
      flavour: item.flavour,
      qtyText: item.quantity
    };
  }

  // Increase quantity if flavour repeated
  grouped[key].quantity += 1;
});

// 2. Convert grouped object into Shopify items[]
// const items = Object.values(grouped).map(item => ({
//   id: item.id,
//   quantity: item.quantity,
//   selling_plan: item.selling_plan
//   // properties: {
//   //   Flavour: item.flavour,
//   //   Quantity: item.qtyText,
//   // }
// }));
var curr_Sel_opt = document.querySelector(".bundle-option.active").dataset.vall;

const items = Object.values(grouped).map(item => {
  const obj = {
    id: item.id,
    quantity: item.quantity
  };

  // Add selling_plan only if subscription selected
  if (curr_Sel_opt === "subs_and_save") {
    obj.selling_plan = item.selling_plan;
  }

  return obj;
});




  if (items.length === 0) return;
console.log("obj ",curr_Sel_opt +'  '+ items);
  // Add to cart
  try {
    const response = await fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    const data = await response.json();
    console.log("Added to cart:", data);
    refreshCart();

    // OPTIONAL — refresh cart drawer
    // document.dispatchEvent(new CustomEvent("cart:refresh"));

  } catch (error) {
    console.error("Add to cart error:", error);
  }
}


document.querySelector('.custom_Add_to_cart_button')
  .addEventListener('click', addSelectedVariantsToCart);







function refreshCart(){
  fetch('/cart?section_id=cart-drawer', {
  method: 'GET',
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})
.then(response => response.text())
.then(html => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  console.log("Cart drawer HTML:", doc.querySelector("cart-drawer"));

  const newDrawer = doc.querySelector('cart-drawer');
  const existingDrawer = document.querySelector('cart-drawer');

  if (newDrawer && existingDrawer) {
    existingDrawer.innerHTML = newDrawer.innerHTML;
      existingDrawer.classList.add("active");
      existingDrawer.classList.remove("is-empty");

      
  }
})
.catch(error => {
  console.error("Cart drawer error:", error);
});
}





// Main cart page - clear cart

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".main-cart_item_remove");
  if (!btn) return;

  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(res => res.json())
    .then(data => {
      console.log("Cart cleared:", data);
      window.location.href = "https://juicisupplements.co.uk/products/juici-2-in-1-booty-beauty-blend";
    })
    .catch(err => {
      console.error("Error:", err);
    });
});















// this function again select the app widget option on changinig the variant
function handleBundleSelection() {
  // Get the checked bundle radio
  const checkedInput = document.querySelector(
    '.bundle-option input[name="bundle-choice"]:checked'
  );

  if (!checkedInput) return;

  // Get the selected bundle option wrapper
  const selectedOption = checkedInput.closest('.bundle-option');
  if (!selectedOption) return;

  // Remove active class from all bundle options
  document.querySelectorAll('.bundle-option').forEach((opt) => {
    opt.classList.remove('active');
  });

  // Add active class to the selected one
  selectedOption.classList.add('active');

  // Get Appstle radio inputs
  const appstleOneTime = document.querySelector(
    '.appstle_subscription_wrapper input#appstle_selling_plan_label_10'
  );
  const appstleSubscribe = document.querySelector(
    '.appstle_subscription_wrapper input#appstle_selling_plan_label_20'
  );

  // Safety check
  if (!appstleOneTime || !appstleSubscribe) {
    console.warn('⚠️ Appstle inputs not found.');
    return;
  }

  // Logic: Match class and trigger corresponding Appstle input
  if (selectedOption.classList.contains('subscribe_save')) {
    console.log("11subs_save__");

    appstleSubscribe.checked = true;
    appstleSubscribe.dispatchEvent(new Event('change', { bubbles: true }));

    const wrapper = selectedOption.closest('.variant-wrapper');
    wrapper?.classList.add('subscribe_save_active');
    wrapper?.classList.remove('onetime_active');

    console.log('✅ Switched to Subscribe & Save');

  } else if (selectedOption.classList.contains('one_time')) {
    console.log("11one_time__");

    appstleOneTime.checked = true;
    appstleOneTime.dispatchEvent(new Event('change', { bubbles: true }));

    const wrapper = selectedOption.closest('.variant-wrapper');
    wrapper?.classList.remove('subscribe_save_active');
    wrapper?.classList.add('onetime_active');

    const { html, price } = getOneTimePriceDetails();
    getOneTimeCustomButton(selectedOption, html, price);

    console.log(price);
    console.log('✅ Switched to One Time Purchase');
  }
}
